import styled from 'styled-components';

import { ChevronIcon } from '@assets/icons';
import {
  StyledArrowCenterBox,
  StyledArrowTopLeft,
  StyledArrowTopRight,
  StyledDotCenter,
  StyledFlexStatusBoxContainer,
} from '@components/BookingProcessModal/common';
import { StatusBox } from '@components/BookingProcessModal/components/StatusBox';
import { StatusBoxContent } from '@components/BookingProcessModal/components/StatusBoxContent';
import theme from '@styles/theme';

export const FirstStep = () => {
  return (
    <StyledContainer>
      <StatusBox
        title='Step 1: Availability Check'
        headerBackground={theme.palette.primary[17]}
        borderColor={theme.palette.primary[17]}
        content='When you receive an Availability Check (or Avail Check) message, this means you may be a fit for the role!'
        className='position-relative'
      >
        <StyledArrowTopLeft
          arrowRadius={ARROW_RADIUS}
          verticalGapDesktop={VERTICAL_GAP_DESKTOP}
          verticalGapMobile={VERTICAL_GAP_MOBILE}
        >
          <div className='actual-arrow' />
        </StyledArrowTopLeft>
        <StyledArrowTopRight
          arrowRadius={ARROW_RADIUS}
          verticalGapDesktop={VERTICAL_GAP_DESKTOP}
          verticalGapMobile={VERTICAL_GAP_MOBILE}
        >
          <div className='actual-arrow' />
        </StyledArrowTopRight>
        <StyledDotCenter dotSize={DOT_SIZE} dotPadding={DOT_PADDING}>
          <div className='actual-dot' />
        </StyledDotCenter>
      </StatusBox>
      <StyledFlexStatusBoxContainer
        horizontalGapDesktop={HORIZONTAL_GAP_DESKTOP}
        verticalGapDesktop={VERTICAL_GAP_DESKTOP}
        horizontalGapMobile={HORIZONTAL_GAP_MOBILE}
        verticalGapMobile={VERTICAL_GAP_MOBILE}
      >
        <StyledStatusBox
          title='Submit to Job'
          headerBackground={theme.palette.color[14]}
          borderColor={theme.palette.primary[18]}
          content={
            <StatusBoxContent
              content='If you’re available and interested in the role, submit your profile.
        This adds you to casting’s pool of potential candidates.'
              statusLabel='Available'
              statusColor={'#8551d9'}
            />
          }
        >
          <StyledArrowCenterBox
            horizontalGapDesktop={HORIZONTAL_GAP_DESKTOP}
            verticalGapDesktop={VERTICAL_GAP_DESKTOP}
            arrowRadius={ARROW_RADIUS}
            horizontalGapMobile={HORIZONTAL_GAP_MOBILE}
            verticalGapMobile={VERTICAL_GAP_MOBILE}
          >
            <div className='chevron-container'>
              <ChevronIcon direction='down' stroke={theme.palette.stroke[1]} />
            </div>
            <div className='chevron-container right-chevron-container'>
              <ChevronIcon direction='down' stroke={theme.palette.stroke[1]} />
            </div>
          </StyledArrowCenterBox>
        </StyledStatusBox>
        <StyledStatusBox
          title='Unavailable'
          headerBackground={theme.palette.primary[19]}
          borderColor={theme.palette.stroke[1]}
          content={
            <StatusBoxContent
              content='If you’re unavailable, let casting know. This will not negatively impact your profile.'
              statusLabel='Unavailable'
              statusColor={theme.palette.color[0]}
            />
          }
        />
      </StyledFlexStatusBoxContainer>
    </StyledContainer>
  );
};

const StyledContainer = styled.div`
  padding: 40px 40px 0px;
  height: 100%;

  @media (max-width: 960px) {
    padding: 20px 20px 24px;
  }
`;

const VERTICAL_GAP_DESKTOP = 72;
const VERTICAL_GAP_MOBILE = 42;

const HORIZONTAL_GAP_DESKTOP = 21;
const HORIZONTAL_GAP_MOBILE = 12;

const ARROW_RADIUS = 8;

const StyledStatusBox = styled(StatusBox)`
  flex: 1;
  position: relative;
`;

const DOT_SIZE = 5;
const DOT_PADDING = 3;
